export const SET_NAVIGATION_STATE = "auth/SET_NAVIGATION_STATE";
export const SET_EXPORTERS = "exporters/SET_EXPORTERS";
export const SET_TIME_PERIODS = "exporters/SET_TIME_PERIODS";
export const ADD_TIME_PERIOD = "exporters/ADD_TIME_PERIOD";
export const DELETE_TIME_PERIOD = "exporters/DELETE_TIME_PERIOD";
export const SET_ACCOUNT_STATE = "account/SET_ACCOUNT_STATE";
